import { useEffect } from "react";
import { Menubar } from "primereact/menubar";
import { MenuItem } from "primereact/menuitem";
import { useNavigate } from "react-router-dom";
import { useInspectionId } from "../hooks/useInspectionId";
import { InspectionGradeInfo } from "../components/Inspection/InspectionGradeInfo";
import { useAppSelector, useAppDispatch } from "../hooks/storeHooks";
import { selectInspection } from "../store/selectors/inspectionSelectors";
import { fetchInspectionData } from "../store/thunks/inspectionThunks";
import {
  filterNavItemsByFlags,
  getInspectionNavItems,
} from "../config/navigation";
import { useFlags } from "launchdarkly-react-client-sdk";
import { PageHeader } from "../components/Shared/PageHeader";
import checklistReviewIcon from "../assets/checklistReview.svg";

export default function Home() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const inspectionId = useInspectionId();
  const { inspection, loading } = useAppSelector(selectInspection);
  const flags = useFlags();

  useEffect(() => {
    if (inspectionId && !inspection) {
      dispatch(fetchInspectionData(inspectionId));
    }
  }, [inspectionId, inspection]);

  // Same items and order as the burger sidebar; the checklist entry also
  // waits for the inspection to load, as its route only makes sense then.
  const items: MenuItem[] = filterNavItemsByFlags(
    getInspectionNavItems(inspectionId ?? ""),
    flags
  )
    .filter((item) => item.key !== "checklist" || inspection)
    .map((item) => ({
      label: item.label,
      icon:
        item.key === "checklist" ? (
          <img
            src={checklistReviewIcon}
            alt={item.label}
            className="icon-checklist-review-menubar"
          />
        ) : (
          item.icon
        ),
      command: () => navigate(item.url),
    }));

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="card">
      <PageHeader title="Technical Review App" />
      <Menubar model={items} />
      <InspectionGradeInfo />
    </div>
  );
}
